import { DialogService } from './dialog.service';

export const DIALOG_SERVICE_PROVIDERS = [DialogService];

export * from './dialog.service';
export * from './dialog.service.mock';
